import {Component, Inject} from 'ng-metadata/core';
import {MediaQueries} from '../infra/mediaQueries.service';
import {MappingTablesCache} from '../mappingTablesCache/mappingTablesCache.service';
import {getShowICPLicenseFooter} from '../appConfig/appConfigForward';

@Component({
    selector: 'prm-explore-footer',
    templateUrl: 'components/primoExplore/primo-explore-footer.html'
})

export class PrimoExploreFooter {

    constructor(private mediaQueries: MediaQueries,
                private mappingTablesCache: MappingTablesCache) {


    }

    private get showICPLicenseFooter(){
        let showICPLicenseFooter = false;
        let showICPLicenseFooterValue = getShowICPLicenseFooter();
        if (showICPLicenseFooterValue
            && (showICPLicenseFooterValue.toLowerCase() === 'yes' || showICPLicenseFooterValue.toLowerCase() === 'true')) { 
            showICPLicenseFooter = true;
        }
        return showICPLicenseFooter;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreFooter.directive.ts